import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime.js";
import "dayjs/locale/zh-cn.js";

dayjs.extend(relativeTime);
dayjs.locale("zh-cn");

const fallbackAvatar = new URL("../../assets/default-avatar.png", import.meta.url).href;
const fallbackArtwork = {
  theme: "cobalt",
  eyebrow: "GRAPHIC DESIGN",
  title: "视觉\n提案",
  subtitle: "DESIGN CASE",
  code: "图π",
};

export function adaptPost(post) {
  const author = post.author || {};
  const cover = post.cover_media || {};

  return {
    id: String(post.id),
    authorId: author.id || post.author_id,
    author: author.nickname || author.username || `用户 ${post.author_id}`,
    username: author.username || `user_${post.author_id}`,
    location: post.address_detail || post.address || "",
    avatar: author.avatar_url || fallbackAvatar,
    image: cover.file_url || null,
    artwork: cover.file_url ? null : fallbackArtwork,
    caption: post.title || "分享了一个平面设计作品",
    likes: Number(post.like_count || 0),
    comments: Number(post.comment_count || 0),
    time: post.created_at ? dayjs(post.created_at).fromNow() : "刚刚",
    liked: Boolean(post.is_liked ?? post.liked ?? post.isLiked),
    saved: Boolean(post.is_collected ?? post.collected ?? post.isCollected),
    tags: (post.tags || []).map((tag) => tag.name).filter(Boolean),
  };
}

export function adaptPostDetail(post) {
  const adapted = adaptPost(post);
  return {
    ...adapted,
    content: post.content || adapted.caption,
    mediaItems: post.media_items || [],
    topics: (post.topics || []).map((topic) => topic.name).filter(Boolean),
    views: Number(post.view_count || 0),
    reviewStatus: post.review_status || "",
  };
}

export function normalizeCursorPage(payload) {
  if (Array.isArray(payload)) {
    return { items: payload, next: null, previous: null };
  }
  return {
    items: payload?.results || [],
    next: payload?.next || null,
    previous: payload?.previous || null,
  };
}
